import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMU = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M3.04 13.043 25 15.217l21.96-2.174C42.72 5.274 34.476 0 25 0S7.28 5.272 3.04 13.043Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M3.04 36.956 25 39.13l21.96-2.174A24.89 24.89 0 0 0 50 24.999l-25-2.174L0 25c0 4.331 1.102 8.405 3.04 11.957Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M3.04 13.042A24.889 24.889 0 0 0 0 25h50a24.89 24.89 0 0 0-3.04-11.957H3.04Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50.001c9.476 0 17.72-5.272 21.96-13.043H3.04C7.28 44.728 15.524 50 25 50Z"
}));
FlagMU.displayName = 'FlagMU';
export default withFlagWrapper(FlagMU);
//# sourceMappingURL=index.js.map